<template>
    <div class="main">
        <c-panel title="ATAS" titleIcon="fas fa-scroll">
            <el-row :gutter="10" class="u-mb-10">
                <el-col :xs="24" :sm="6">
                    <el-input v-model="filtro.busca" placeholder="Buscar por número ou título" @keyup.enter.native="load" clearable></el-input>
                </el-col>
                <el-col :xs="24" :sm="6">
                    <el-select v-model="filtro.tipo_ata_id" placeholder="Tipo" filterable clearable @change="load" style="width:100%;">
                        <el-option v-for="t in tipos" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" class="u-text-right">
                    <router-link to="/admin/ata/cadastro"><el-button type="primary" icon="el-icon-plus">NOVA ATA</el-button></router-link>
                </el-col>
            </el-row>

            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width:80px;">Cod</th>
                        <th style="width:110px;">Nº</th>
                        <th>Título</th>
                        <th style="width:140px;">Tipo</th>
                        <th style="width:110px;">Data</th>
                        <th style="width:100px;">Status</th>
                        <th style="width:200px;" class="u-text-center">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="a in items" :key="a.id">
                        <td>{{ a.id }}</td>
                        <td>{{ a.numero || '—' }}</td>
                        <td>{{ a.titulo }}</td>
                        <td>{{ a.tipo_ata ? a.tipo_ata.nome : '—' }}</td>
                        <td>{{ a.data_ata | formatarData }}</td>
                        <td>
                            <el-tag :type="a.finalizada ? 'success' : 'warning'" size="mini">
                                {{ a.finalizada ? 'Finalizada' : 'Rascunho' }}
                            </el-tag>
                        </td>
                        <td class="u-text-center">
                            <router-link :to="'/admin/ata/edit/' + a.id">
                                <el-button size="mini" type="info" icon="el-icon-edit" plain></el-button>
                            </router-link>
                            <el-button class="u-ml-10" size="mini" type="primary" plain @click="imprimir(a)" icon="el-icon-printer"></el-button>
                            <el-button v-if="!a.finalizada" size="mini" type="danger" plain icon="el-icon-delete" @click="excluir(a.id)"></el-button>
                        </td>
                    </tr>
                    <tr v-if="!items.length">
                        <td colspan="7" class="u-text-center" style="padding: 20px; color: #909399;">Nenhuma ata cadastrada.</td>
                    </tr>
                </tbody>
            </table>
        </c-panel>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    filters: { formatarData (v) { return v ? moment(v).format('DD/MM/YYYY') : '' } },
    data () {
        return {
            items: [], tipos: [],
            filtro: { busca: '', tipo_ata_id: null }
        }
    },
    mounted () {
        this.load()
        this.carregarTipos()
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        load () {
            this.$axios.post(`${this.baseUrl()}/api/ata/getAllPaginate`,
                { instituicao_id: this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null, ...this.filtro },
                this.$store.getters.getHeaderAuth
            ).then(r => { this.items = (r.data && r.data.data) ? r.data.data : (r.data || []) })
              .catch(e => this.$store.commit('throwException', e))
        },
        carregarTipos () {
            this.$axios.post(`${this.baseUrl()}/api/tipo-ata/getAllPaginate`, { situacao: true }, this.$store.getters.getHeaderAuth)
                .then(r => { this.tipos = (r.data && r.data.data) ? r.data.data : (r.data || []) })
                .catch(() => { this.tipos = [] })
        },
        excluir (id) {
            this.$confirm('Excluir esta ata?', 'Confirmar', { type: 'warning' }).then(() => {
                this.$axios.delete(`${this.baseUrl()}/api/ata/delete/${id}`, this.$store.getters.getHeaderAuth).then(r => {
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Excluída.', type: 'success' })
                    this.load()
                })
            }).catch(() => {})
        },
        imprimir (a) {
            this.$axios.get(`${this.baseUrl()}/api/ata/imprimir/${a.id}`, {
                ...this.$store.getters.getHeaderAuth,
                responseType: 'blob'
            }).then(r => {
                const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }))
                window.open(url, '_blank')
            }).catch(e => this.$store.commit('throwException', e))
        }
    }
}
</script>
